let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("sv9xx")).then(() => parcelRequire('5kbqa'));